<template>
<div class="chapter">
<div class="inner_page">
<p class="center">A<span class="smallcaps">LSO</span> B<span class="smallcaps">Y</span> H<span class="smallcaps">AYWOOD</span> S<span class="smallcaps">MITH</span></p>
<p class="center"><em>The Red Hat Club</em></p>
<p class="center"><em>Queen Bee of Mimosa Branch</em></p>
<p class="center"><em>The Red Hat Club Rides Again</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front1.vue?7da5aef4